var _style, _g, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSiteLayoutToolkitLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 721.2 66.9",
    style: {
      enableBackground: "new 0 0 721.2 66.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0069B0;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{opacity:0.48;fill:#0069B0;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.8,39.3l6.8-0.7c0.4,2.3,1.2,3.9,2.5,5s2.9,1.6,5,1.6c2.2,0,3.9-0.5,5.1-1.4s1.7-2.1,1.7-3.3 c0-0.8-0.2-1.5-0.7-2.1s-1.3-1.1-2.5-1.5c-0.8-0.3-2.7-0.8-5.6-1.5c-3.7-0.9-6.3-2.1-7.8-3.4c-2.1-1.9-3.2-4.2-3.2-6.9 c0-1.8,0.5-3.4,1.5-4.9s2.4-2.7,4.3-3.5s4.1-1.2,6.8-1.2c4.3,0,7.6,0.9,9.7,2.8s3.3,4.4,3.4,7.6l-6.9,0.3c-0.3-1.8-0.9-3-1.9-3.8 s-2.4-1.2-4.4-1.2c-2,0-3.6,0.4-4.7,1.2c-0.7,0.5-1.1,1.2-1.1,2.1c0,0.8,0.3,1.5,1,2.1c0.9,0.7,3,1.5,6.4,2.3s5.9,1.6,7.5,2.5 s2.9,2,3.8,3.5s1.4,3.3,1.4,5.5c0,2-0.5,3.8-1.6,5.5s-2.6,3-4.6,3.8s-4.5,1.3-7.5,1.3c-4.3,0-7.7-1-10-3S120.3,43.2,119.8,39.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M153.4,50.5V16.1h6.9v34.4H153.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M174.7,50.5V21.9h-10.2v-5.8h27.3v5.8h-10.2v28.5H174.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.3,50.5V16.1h25.5v5.8h-18.5v7.6h17.2v5.8h-17.2v9.4h19.2v5.8H196.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.8,50.5V16.4h6.9v28.3H266v5.8H241.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M301.9,50.5h-7.5l-3-7.8h-13.7l-2.8,7.8h-7.4l13.4-34.4h7.3L301.9,50.5z M289.2,36.9l-4.7-12.8l-4.6,12.8 H289.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M310.2,50.5V36l-12.6-19.9h8.1l8.1,13.6l7.9-13.6h8l-12.6,19.9v14.4H310.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M331.8,33.5c0-3.5,0.5-6.4,1.6-8.8c0.8-1.8,1.8-3.3,3.2-4.7s2.8-2.4,4.4-3.1c2.1-0.9,4.6-1.4,7.4-1.4 c5.1,0,9.1,1.6,12.2,4.7s4.6,7.5,4.6,13.1c0,5.5-1.5,9.9-4.5,13s-7,4.7-12.1,4.7c-5.1,0-9.2-1.6-12.2-4.7S331.8,39,331.8,33.5z  M339,33.3c0,3.9,0.9,6.8,2.7,8.8s4.1,3,6.8,3s5-1,6.8-3s2.7-5,2.7-9c0-3.9-0.9-6.9-2.6-8.8s-4-2.9-6.9-2.9s-5.2,1-6.9,2.9 S339,29.3,339,33.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M370.5,16.1h6.9v18.6c0,3,0.1,4.9,0.3,5.7c0.3,1.4,1,2.5,2.1,3.4s2.6,1.3,4.6,1.3c2,0,3.5-0.4,4.5-1.2 s1.6-1.8,1.8-3s0.3-3.1,0.3-5.8v-19h6.9v18c0,4.1-0.2,7-0.6,8.7s-1.1,3.1-2.1,4.3s-2.4,2.1-4,2.8s-3.9,1-6.6,1 c-3.3,0-5.8-0.4-7.5-1.1s-3-1.7-4-3s-1.6-2.5-1.9-3.8c-0.5-2-0.7-4.9-0.7-8.7V16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M413,50.5V21.9h-10.2v-5.8h27.3v5.8h-10.2v28.5H413z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M455.6,50.5V21.9h-10.2v-5.8h27.3v5.8h-10.2v28.5H455.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M474.9,33.5c0-3.5,0.5-6.4,1.6-8.8c0.8-1.8,1.8-3.3,3.2-4.7s2.8-2.4,4.4-3.1c2.1-0.9,4.6-1.4,7.4-1.4 c5.1,0,9.1,1.6,12.2,4.7s4.6,7.5,4.6,13.1c0,5.5-1.5,9.9-4.5,13s-7,4.7-12.1,4.7c-5.1,0-9.2-1.6-12.2-4.7S474.9,39,474.9,33.5z  M482.1,33.3c0,3.9,0.9,6.8,2.7,8.8s4.1,3,6.8,3s5-1,6.8-3s2.7-5,2.7-9c0-3.9-0.9-6.9-2.6-8.8s-4-2.9-6.9-2.9s-5.2,1-6.9,2.9 S482.1,29.3,482.1,33.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M512.3,33.5c0-3.5,0.5-6.4,1.6-8.8c0.8-1.8,1.8-3.3,3.2-4.7s2.8-2.4,4.4-3.1c2.1-0.9,4.6-1.4,7.4-1.4 c5.1,0,9.1,1.6,12.2,4.7s4.6,7.5,4.6,13.1c0,5.5-1.5,9.9-4.5,13s-7,4.7-12.1,4.7c-5.1,0-9.2-1.6-12.2-4.7S512.3,39,512.3,33.5z  M519.4,33.3c0,3.9,0.9,6.8,2.7,8.8c1.8,2,4.1,3,6.8,3s5-1,6.8-3s2.7-5,2.7-9c0-3.9-0.9-6.9-2.6-8.8s-4-2.9-6.9-2.9s-5.2,1-6.9,2.9 C520.3,26.4,519.4,29.3,519.4,33.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M551.2,50.5V16.4h6.9v28.3h17.2v5.8H551.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M580.4,50.5V16.1h6.9v15.3l14-15.3h9.3l-12.9,13.4l13.6,21h-9L593,34.4l-5.6,5.7v10.4H580.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M614.8,50.5V16.1h6.9v34.4H614.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M636.1,50.5V21.9h-10.2v-5.8h27.3v5.8H643v28.5H636.1z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 49.4184,
    cy: 32.692,
    r: 19.9742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5744,
    style: {
      stopColor: "#0069B0",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7977,
    style: {
      stopColor: "#0069B0",
      stopOpacity: 0.6512
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0069B0",
      stopOpacity: 0.95
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 49.4,
    cy: 32.7,
    r: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M69.4,30.9c0.1,0.9,0.1,2,0,3.2c-0.2,2.2-0.7,4-1,5.1c-1,2.9-2.5,5-3.5,6.3c-1.1,1.3-3.2,3.5-6.5,5.2 c-1.2,0.6-3.3,1.5-6,1.9c-1.6,0.2-4,0.4-6.8-0.2c-1.5-0.3-3.8-0.9-6.2-2.4c-1.1-0.6-2.7-1.7-4.3-3.4c-2-2.1-3.1-4.1-3.7-5.3 c-0.6-1.2-1.4-3.3-1.7-6c-0.2-1.7-0.2-3.2-0.1-4.3c1.4,1.9,4.7,6,9.8,6.8c2.6,0.4,4.6-0.2,8.7-1.4c6.3-1.9,7.6-3.6,12.5-4.8 C62.7,31,65.7,30.6,69.4,30.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteLayoutToolkitLogo);
export default __webpack_public_path__ + "static/media/site-layout-toolkit-logo.67e2c96f57b95ccc29e8263b3b91e031.svg";
export { ForwardRef as ReactComponent };